
import React from "react";
import { DataHelper } from "../Helpers/DataHelper";
// You may need to adjust the import path for DataHelper if needed


export class AuthPage extends React.Component<
  { redirectUrl: string, dataHelper: DataHelper, isLocalInstall: boolean },
  {
    email: string;
    otp: string;
    step: "init" | "email" | "otp" | "done";
    error?: string;
    loading?: boolean;
  }
> {
  constructor(props: { redirectUrl: string, dataHelper: DataHelper, isLocalInstall: boolean }) {
    super(props);
    this.state = {
      email: "",
      otp: "",
      step: "init",
      error: undefined,
      loading: false,
    };
  }

  handleEmailLoginClick = () => {
    this.setState({ step: "email", error: undefined });
  };

  handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ email: e.target.value });
  };

  handleOtpChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ otp: e.target.value });
  };

  handleSendOtp = () => {
    const { email } = this.state;
    if (!email) {
      this.setState({ error: "Please enter your email." });
      return;
    }
    this.setState({ loading: true, error: undefined });
    this.props.dataHelper.CallService(
      "auth",
      "request-otp",
      { email: email },
      {},
      () => {
        this.setState({ step: "otp", loading: false });
      },
      (status: number, err: string) => {
        this.setState({ error: err || "Failed to send OTP.", loading: false });
      },
      "POST"
    );
  };

  handleVerifyOtp = () => {
    const { email, otp } = this.state;
    if (!otp) {
      this.setState({ error: "Please enter the OTP." });
      return;
    }
    this.setState({ loading: true, error: undefined });
    this.props.dataHelper.CallService(
      "auth",
      "verify-otp",
      { email: email, otp: otp },
      {},
      (response: string) => {
        try {
          const data = JSON.parse(response);
          if (data && data.token) {
            // Store token (localStorage or as needed)
            localStorage.setItem("auth_token", data.token);
            localStorage.setItem("user_id", email);
            localStorage.setItem("auth_method", "email");
            this.setState({ step: "done", loading: false });
            // Redirect to landing page
            window.location.href = this.props.redirectUrl;
           
          } else {
            this.setState({ error: "Invalid response from server.", loading: false });
          }
        } catch (e) {
          this.setState({ error: "Failed to parse server response.", loading: false });
        }
      },
      (status: number, err: string) => {
        this.setState({ error: err || "Failed to verify OTP.", loading: false });
      },
      "POST"
    );
  };

  render() {
    const { step, email, otp, error, loading } = this.state;
    return (
      <>
       
<div className="superHeader dashboardHeader">
  
  <span className="superName">
      <span className="medLogo"><img src="/logoOrange.svg" alt="Meaningful text" /></span>
      <span className="medMiniText">case cloud</span>
  </span>

        </div>

        <div className="content">
          {step === "init" && (
            <>
              <a className="bigButton leftButton" href={this.props.redirectUrl + ".auth/login/aad?post_login_redirect_uri=.referrer"}>
                 <span className="logoHere">
                  <svg version="1.1" id="MS-symbol" x="0px" y="0px" viewBox="0 0 337.6 72">
                    <path className="st0" d="M140.4,14.4v43.2h-7.5V23.7h-0.1l-13.4,33.9h-5l-13.7-33.9h-0.1v33.9h-6.9V14.4h10.8l12.4,32h0.2l13.1-32H140.4  z M146.6,17.7c0-1.2,0.4-2.2,1.3-3c0.9-0.8,1.9-1.2,3.1-1.2c1.3,0,2.4,0.4,3.2,1.2s1.3,1.8,1.3,3c0,1.2-0.4,2.2-1.3,3  c-0.9,0.8-1.9,1.2-3.2,1.2s-2.3-0.4-3.1-1.2C147.1,19.8,146.6,18.8,146.6,17.7z M154.7,26.6v31h-7.3v-31H154.7z M176.8,52.3  c1.1,0,2.3-0.2,3.6-0.8c1.3-0.5,2.5-1.2,3.6-2v6.8c-1.2,0.7-2.5,1.2-4,1.5c-1.5,0.3-3.1,0.5-4.9,0.5c-4.6,0-8.3-1.4-11.1-4.3  c-2.9-2.9-4.3-6.6-4.3-11c0-5,1.5-9.1,4.4-12.3c2.9-3.2,7-4.8,12.4-4.8c1.4,0,2.8,0.2,4.1,0.5c1.4,0.3,2.5,0.8,3.3,1.2v7  c-1.1-0.8-2.3-1.5-3.4-1.9c-1.2-0.4-2.4-0.7-3.6-0.7c-2.9,0-5.2,0.9-7,2.8s-2.6,4.4-2.6,7.6c0,3.1,0.9,5.6,2.6,7.3  C171.6,51.4,173.9,52.3,176.8,52.3z M204.7,26.1c0.6,0,1.1,0,1.6,0.1s0.9,0.2,1.2,0.3v7.4c-0.4-0.3-0.9-0.6-1.7-0.8  s-1.6-0.4-2.7-0.4c-1.8,0-3.3,0.8-4.5,2.3s-1.9,3.8-1.9,7v15.6h-7.3v-31h7.3v4.9h0.1c0.7-1.7,1.7-3,3-4  C201.2,26.6,202.8,26.1,204.7,26.1z M207.9,42.6c0-5.1,1.5-9.2,4.3-12.2c2.9-3,6.9-4.5,12-4.5c4.8,0,8.6,1.4,11.3,4.3  s4.1,6.8,4.1,11.7c0,5-1.5,9-4.3,12c-2.9,3-6.8,4.5-11.8,4.5c-4.8,0-8.6-1.4-11.4-4.2C209.3,51.3,207.9,47.4,207.9,42.6z   M215.5,42.3c0,3.2,0.7,5.7,2.2,7.4s3.6,2.6,6.3,2.6c2.6,0,4.7-0.8,6.1-2.6c1.4-1.7,2.1-4.2,2.1-7.6c0-3.3-0.7-5.8-2.1-7.6  c-1.4-1.7-3.5-2.6-6-2.6c-2.7,0-4.7,0.9-6.2,2.7C216.2,36.5,215.5,39,215.5,42.3z M250.5,34.8c0,1,0.3,1.9,1,2.5  c0.7,0.6,2.1,1.3,4.4,2.2c2.9,1.2,5,2.5,6.1,3.9c1.2,1.5,1.8,3.2,1.8,5.3c0,2.9-1.1,5.2-3.4,7c-2.2,1.8-5.3,2.6-9.1,2.6  c-1.3,0-2.7-0.2-4.3-0.5c-1.6-0.3-2.9-0.7-4-1.2v-7.2c1.3,0.9,2.8,1.7,4.3,2.2c1.5,0.5,2.9,0.8,4.2,0.8c1.6,0,2.9-0.2,3.6-0.7  c0.8-0.5,1.2-1.2,1.2-2.3c0-1-0.4-1.8-1.2-2.6c-0.8-0.7-2.4-1.5-4.6-2.4c-2.7-1.1-4.6-2.4-5.7-3.8s-1.7-3.2-1.7-5.4  c0-2.8,1.1-5.1,3.3-6.9c2.2-1.8,5.1-2.7,8.6-2.7c1.1,0,2.3,0.1,3.6,0.4s2.5,0.6,3.4,0.9V34c-1-0.6-2.1-1.2-3.4-1.7  c-1.3-0.5-2.6-0.7-3.8-0.7c-1.4,0-2.5,0.3-3.2,0.8C250.9,33.1,250.5,33.8,250.5,34.8z M266.9,42.6c0-5.1,1.5-9.2,4.3-12.2  c2.9-3,6.9-4.5,12-4.5c4.8,0,8.6,1.4,11.3,4.3s4.1,6.8,4.1,11.7c0,5-1.5,9-4.3,12c-2.9,3-6.8,4.5-11.8,4.5c-4.8,0-8.6-1.4-11.4-4.2  C268.4,51.3,266.9,47.4,266.9,42.6z M274.5,42.3c0,3.2,0.7,5.7,2.2,7.4s3.6,2.6,6.3,2.6c2.6,0,4.7-0.8,6.1-2.6  c1.4-1.7,2.1-4.2,2.1-7.6c0-3.3-0.7-5.8-2.1-7.6c-1.4-1.7-3.5-2.6-6-2.6c-2.7,0-4.7,0.9-6.2,2.7C275.3,36.5,274.5,39,274.5,42.3z   M322.9,32.6h-10.9v25h-7.4v-25h-5.2v-6h5.2v-4.3c0-3.2,1.1-5.9,3.2-8s4.8-3.1,8.1-3.1c0.9,0,1.7,0.1,2.4,0.1s1.3,0.2,1.8,0.4v6.3  c-0.2-0.1-0.7-0.3-1.3-0.5c-0.6-0.2-1.3-0.3-2.1-0.3c-1.5,0-2.7,0.5-3.5,1.4c-0.8,0.9-1.2,2.4-1.2,4.2v3.7h10.9v-7l7.3-2.2v9.2h7.4  v6h-7.4v14.5c0,1.9,0.4,3.2,1,4c0.7,0.8,1.8,1.2,3.3,1.2c0.4,0,0.9-0.1,1.5-0.3c0.6-0.2,1.1-0.4,1.5-0.7v6c-0.5,0.3-1.2,0.5-2.3,0.7  c-1.1,0.2-2.1,0.3-3.2,0.3c-3.1,0-5.4-0.8-6.9-2.4c-1.5-1.6-2.3-4.1-2.3-7.4L322.9,32.6L322.9,32.6z"/>
                    <g>
                      <rect className="st1" width="34.2" height="34.2"/>
                      <rect x="37.8" className="st2" width="34.2" height="34.2"/>
                      <rect y="37.8" className="st3" width="34.2" height="34.2"/>
                      <rect x="37.8" y="37.8" className="st4" width="34.2" height="34.2"/>
                    </g>
                  </svg>
                </span>
                <span className="textHere">Login with Microsoft</span>
              </a>
              <a className="bigButton middleButton" href={this.props.redirectUrl + ".auth/login/google?post_login_redirect_uri=.referrer"}>
                <span className="logoHere">
                  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 272 92" width="272" height="92">
                    <path fill="#EA4335" d="M115.75 47.18c0 12.77-9.99 22.18-22.25 22.18s-22.25-9.41-22.25-22.18C71.25 34.32 81.24 25 93.5 25s22.25 9.32 22.25 22.18zm-9.74 0c0-7.98-5.79-13.44-12.51-13.44S80.99 39.2 80.99 47.18c0 7.9 5.79 13.44 12.51 13.44s12.51-5.55 12.51-13.44z"/>
                    <path fill="#FBBC05" d="M163.75 47.18c0 12.77-9.99 22.18-22.25 22.18s-22.25-9.41-22.25-22.18c0-12.85 9.99-22.18 22.25-22.18s22.25 9.32 22.25 22.18zm-9.74 0c0-7.98-5.79-13.44-12.51-13.44s-12.51 5.46-12.51 13.44c0 7.9 5.79 13.44 12.51 13.44s12.51-5.55 12.51-13.44z"/>
                    <path fill="#4285F4" d="M209.75 26.34v39.82c0 16.38-9.66 23.07-21.08 23.07-10.75 0-17.22-7.19-19.66-13.07l8.48-3.53c1.51 3.61 5.21 7.87 11.17 7.87 7.31 0 11.84-4.51 11.84-13v-3.19h-.34c-2.18 2.69-6.38 5.04-11.68 5.04-11.09 0-21.25-9.66-21.25-22.09 0-12.52 10.16-22.26 21.25-22.26 5.29 0 9.49 2.35 11.68 4.96h.34v-3.61h9.25zm-8.56 20.92c0-7.81-5.21-13.52-11.84-13.52-6.72 0-12.35 5.71-12.35 13.52 0 7.73 5.63 13.36 12.35 13.36 6.63 0 11.84-5.63 11.84-13.36z"/>
                    <path fill="#34A853" d="M225 3v65h-9.5V3h9.5z"/>
                    <path fill="#EA4335" d="M262.02 54.48l7.56 5.04c-2.44 3.61-8.32 9.83-18.48 9.83-12.6 0-22.01-9.74-22.01-22.18 0-13.19 9.49-22.18 20.92-22.18 11.51 0 17.14 9.16 18.98 14.11l1.01 2.52-29.65 12.28c2.27 4.45 5.8 6.72 10.75 6.72 4.96 0 8.4-2.44 10.92-6.14zm-23.27-7.98l19.82-8.23c-1.09-2.77-4.37-4.7-8.23-4.7-4.95 0-11.84 4.37-11.59 12.93z"/>
                    <path fill="#4285F4" d="M35.29 41.41V32H67c.31 1.64.47 3.58.47 5.68 0 7.06-1.93 15.79-8.15 22.01-6.05 6.3-13.78 9.66-24.02 9.66C16.32 69.35.36 53.89.36 34.91.36 15.93 16.32.47 35.3.47c10.5 0 17.98 4.12 23.6 9.49l-6.64 6.64c-4.03-3.78-9.49-6.72-16.97-6.72-13.86 0-24.7 11.17-24.7 25.03 0 13.86 10.84 25.03 24.7 25.03 8.99 0 14.11-3.61 17.39-6.89 2.66-2.66 4.41-6.46 5.1-11.65l-22.49.01z"/>
                  </svg>
                </span>
                <span className="textHere">Login with Google</span>
              </a>
              {this.props.isLocalInstall && 
              <button className="bigButton rightButton" onClick={this.handleEmailLoginClick} disabled={loading}>
                <span className="textHere">Login with Email</span>
              </button>
              }
            </>
          )}
          {step === "email" && (
            <div className="email-login-form">
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={this.handleEmailChange}
                disabled={loading}
                style={{ marginRight: 8 }}
              />
              <button onClick={this.handleSendOtp} disabled={loading}>
                {loading ? "Sending..." : "Send OTP"}
              </button>
              <button onClick={() => this.setState({ step: "init", error: undefined })} disabled={loading} style={{ marginLeft: 8 }}>
                Cancel
              </button>
              {error && <div style={{ color: "red", marginTop: 8 }}>{error}</div>}
            </div>
          )}
          {step === "otp" && (
            <div className="otp-login-form">
              <div style={{ marginBottom: 8 }}>OTP sent to {email}</div>
              <input
                type="text"
                placeholder="Enter OTP"
                value={otp}
                onChange={this.handleOtpChange}
                disabled={loading}
                style={{ marginRight: 8 }}
              />
              <button onClick={this.handleVerifyOtp} disabled={loading}>
                {loading ? "Verifying..." : "Log In"}
              </button>
              <button onClick={() => this.setState({ step: "email", error: undefined, otp: "" })} disabled={loading} style={{ marginLeft: 8 }}>
                Back
              </button>
              {error && <div style={{ color: "red", marginTop: 8 }}>{error}</div>}
            </div>
          )}
        </div>
      </>
    );
  }
}



